const getMedianNumberAsString = ({ min, max }) => Math.floor((min + max) / 2).toString();

export default ({ id, min = 1, max = 7 }) => {
  const stringifiedId = id?.toString?.() || '';
  const randomNumberFromId = [...stringifiedId].find(
    char => typeof parseInt(char) === 'number' && parseInt(char) >= min && parseInt(char) <= max,
  );
  if (randomNumberFromId) {
    return randomNumberFromId;
  }
  return getMedianNumberAsString({ min, max });
};
